import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3ee65abe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "How to play", -1))
const _hoisted_2 = { class: "icon-list" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Listen to 10 tracks from 10 ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Mario", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" games, each track corresponding to a result in the top 10 of ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "M9. Favourite Soundtrack", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" in 2022. ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Listen to the intro of each track, then find the correct track in the list. ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Skipped or incorrect attempts unlock more of the intro. ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Answer each track in as few tries as possible and share your score at the end! ")
const _hoisted_11 = { class: "close" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createVNode(_component_font_awesome_icon, { icon: ['far','award'] }),
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_font_awesome_icon, { icon: ['far','music'] }),
        _hoisted_8
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_font_awesome_icon, { icon: ['far','forward'] }),
        _hoisted_9
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_font_awesome_icon, { icon: ['far','square-check'] }),
        _hoisted_10
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, "Play!")
    ])
  ], 64))
}